import AppHelper from './app-helper';

export default class Pixels {
  static async triggerPixel(trackid) {
    const trackingData = AppHelper.getCommonTrackingData();
    if (trackingData.utm_id === 'zp') {
      const trackingURL = new URL('https://zeropark.classicspinz.com');

      const params = {
        cid: trackingData.utmContent,
        utm_source: trackingData.utmSource,
        utm_medium: trackingData.utmMedium,
        utm_campaign: trackingData.utmCampaign,
        utm_term: trackingData.keyword,
        track_id: trackid,
        gclid: trackingData.gclid,
      };

      Object.keys(params)
        .forEach((key) => trackingURL.searchParams.append(key, params[key]));

      try {
        const response = await fetch(trackingURL.toString(), {
          method: 'GET',
          mode: 'no-cors',
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Fetch failed:', error);
      }
    }

    return null;
  }

  static taboolaPixel() {
    const trackingData = AppHelper.getCommonTrackingData();
    if (trackingData.utm_id === 'taboola') {
      /* eslint no-underscore-dangle: 0 */
      window._tfa = window._tfa || [];
      window._tfa.push({ notify: 'event', name: 'page_view', id: 1477607 });

      /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["t"] }] */
      /* eslint wrap-iife: [2, "inside", { functionPrototypeMethods: true }] */
      (function loadTaboolaScript(t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = true;
          t.src = a;
          t.id = x;
          f.parentNode.insertBefore(t, f);
        }
      })(
        document.createElement('script'),
        document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/unip/1477607/tfa.js',
        'tb_tfa_script',
      );
      console.log('Jovan');
      /* eslint no-underscore-dangle: 0 */
      window._tfa.push({ notify: 'event', name: 'Lead', id: 1477607 });
    }
  }
}
